import { FC } from 'react';

import './style.scss';

export const SkeletonScanline: FC = () => <div className="skeleton-scanline" />;
